import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bd8e313"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = { class: "px-6 py-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Estabelecimentos Comerciais", -1))
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = {
  key: 0,
  class: "flex h-full w-full flex-col items-center justify-start"
}
const _hoisted_6 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col" }
const _hoisted_7 = { class: "col-span-6 -lg:flex -lg:flex-col" }
const _hoisted_8 = {
  key: 0,
  class: "col-span-12 grid grid-cols-12 gap-x-4 gap-y-2 -lg:flex -lg:flex-col"
}
const _hoisted_9 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_10 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_11 = { class: "grid col-span-4 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_12 = { class: "grid col-span-4 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_13 = { class: "grid col-span-4 grid-cols-12 -lg:flex -lg:flex-col h-full w-full items-center justify-end -lg:h-16" }
const _hoisted_14 = {
  key: 1,
  class: "flex h-full w-full flex-col items-center justify-start"
}
const _hoisted_15 = { class: "grid grid-cols-12 gap-x-4 gap-y-2 -md:flex -md:flex-col" }
const _hoisted_16 = { class: "col-span-12 grid grid-cols-12 gap-x-4 gap-y-2 -md:flex -md:flex-col" }
const _hoisted_17 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_18 = { class: "grid col-span-6 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_19 = { class: "grid col-span-4 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_20 = { class: "grid col-span-4 grid-cols-12 -lg:flex -lg:flex-col" }
const _hoisted_21 = { class: "col-span-4 flex h-full w-full items-center justify-end -lg:h-16 -lg:flex -lg:flex-co" }
const _hoisted_22 = {
  key: 2,
  class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
}
const _hoisted_23 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_24 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-lg" }, "Nenhum estabelecimento encontrado!", -1))
const _hoisted_26 = {
  key: 0,
  class: "shadow overflow-hidden flex border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-60"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("embed", {
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "flex w-full mt-4"
}
const _hoisted_30 = { class: "w-2/5 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Para iniciar o processo de credenciamento, preencha os campos abaixo: ", -1))
const _hoisted_32 = {
  id: "email",
  class: "my-4 p-5 border-grey-300 border rounded-lg"
}
const _hoisted_33 = {
  key: 0,
  alt: "",
  src: "/full-logo-blue.png",
  width: "200",
  height: "50",
  class: "-lg:hidden mx-auto mb-6"
}
const _hoisted_34 = { class: "flex w-full mt-4" }
const _hoisted_35 = { class: "title" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomInputAutocomplete = _resolveComponent("CustomInputAutocomplete")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isRoot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_CustomInputAutocomplete, {
                        label: "Software house *",
                        class: "z-20 col-span-12",
                        searchValue: !_ctx.loadingSoftwareHouses ? _ctx.searchSoftwareHouseText : 'Carregando...',
                        searchFunction: () => (_ctx.softwareHouses = _ctx.searchSoftwareHouses()),
                        disabled: _ctx.loadingSoftwareHouses,
                        delay: 0,
                        minimumCharactersToShowList: 0,
                        listValues: 
                    _ctx.softwareHouses.map(({ nomeFantasia, razaoSocial, cnpj }) => {
                      return {
                        primaryText: nomeFantasia ? nomeFantasia : razaoSocial,
                        secondaryText: `${
                          cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                        } | ${razaoSocial}`,
                        id: cnpj,
                      };
                    })
                  ,
                        inputEvent: "update:input",
                        resultEvent: "update:select",
                        isIncorrect: _ctx.isSoftwareHouseIncorrect,
                        incorrectMessage: "Campo obrigatório!",
                        "onUpdate:input": _ctx.updateSearchSoftwareHouseText,
                        "onUpdate:select": _ctx.getData
                      }, null, 8, ["searchValue", "searchFunction", "disabled", "listValues", "isIncorrect", "onUpdate:input", "onUpdate:select"])
                    ]),
                    (_ctx.softwareHouseSelected)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_Input, {
                              modelValue: _ctx.searchEstabelecimentoText,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchEstabelecimentoText) = $event)),
                              type: "text",
                              label: "Pesquisar estabelecimento",
                              class: "col-span-12"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            (_openBlock(), _createBlock(_component_Select, {
                              label: "Status",
                              options: () => _ctx.optionsStatus,
                              key: _ctx.statusSelected.key,
                              selected: _ctx.statusSelected.value,
                              display: "value",
                              class: "col-span-12",
                              event: "update:select",
                              "onUpdate:select": _ctx.handleStatus
                            }, null, 8, ["options", "selected", "onUpdate:select"]))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_CustomInput, {
                              label: "Data inicial",
                              type: "date",
                              name: "startFilter",
                              validation: _ctx.filterDateStartErrorMessage,
                              value: _ctx.startFilter,
                              onChange: _ctx.changeFilterDate,
                              class: "col-span-12"
                            }, null, 8, ["validation", "value", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_CustomInput, {
                              label: "Data final",
                              type: "date",
                              name: "endFilter",
                              validation: _ctx.filterDateEndErrorMessage,
                              value: _ctx.endFilter,
                              onChange: _ctx.changeFilterDate,
                              class: "col-span-12"
                            }, null, 8, ["validation", "value", "onChange"])
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_PrimaryButton, {
                              label: "Filtrar",
                              icon: _ctx.buttonIcons.search.icon,
                              iconCustomClass: "text-white",
                              width: "w-full",
                              class: "col-span-12",
                              onClick: _withModifiers(_ctx.searchEstabelecimentos, ["prevent"]),
                              type: "submit"
                            }, null, 8, ["icon", "onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_Form, { class: "mt-1 !space-y-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Input, {
                          modelValue: _ctx.searchEstabelecimentoText,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchEstabelecimentoText) = $event)),
                          type: "text",
                          label: "Pesquisar estabelecimento",
                          class: "col-span-12"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(), _createBlock(_component_Select, {
                          label: "Status",
                          options: () => _ctx.optionsStatus,
                          key: _ctx.statusSelected.key,
                          selected: _ctx.statusSelected.value,
                          display: "value",
                          class: "col-span-12",
                          event: "update:select",
                          "onUpdate:select": _ctx.handleStatus
                        }, null, 8, ["options", "selected", "onUpdate:select"]))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_CustomInput, {
                          label: "Data inicial",
                          type: "date",
                          name: "startFilter",
                          validation: _ctx.filterDateStartErrorMessage,
                          value: _ctx.startFilter,
                          onChange: _ctx.changeFilterDate,
                          class: "col-span-12"
                        }, null, 8, ["validation", "value", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_CustomInput, {
                          label: "Data final",
                          type: "date",
                          name: "endFilter",
                          validation: _ctx.filterDateEndErrorMessage,
                          value: _ctx.endFilter,
                          onChange: _ctx.changeFilterDate,
                          class: "col-span-12"
                        }, null, 8, ["validation", "value", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_PrimaryButton, {
                          label: "Filtrar",
                          icon: _ctx.buttonIcons.search.icon,
                          iconCustomClass: "text-white",
                          width: "w-full",
                          class: "col-span-12",
                          onClick: _withModifiers(_ctx.searchEstabelecimentos, ["prevent"]),
                          type: "submit"
                        }, null, 8, ["icon", "onClick"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])),
        (_ctx.estabelecimentos.length !== 0 && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(), _createBlock(_component_Table, {
                    columns: 
                  ['CNPJ', 'Razão Social', 'Data do Cadastro', 'Tarifa padrão', 'Status']
                ,
                    buttons: ['edit'],
                    itemsPerPage: 20,
                    "onUpdate:editTableItem": _ctx.handleEdit,
                    values: () => _ctx.estabelecimentos.map(({ cnpj, razaoSocial, dataAtivacao, mediatorFee, status }) => {
                  return {
                    cnpj: cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'),
                    razaoSocial,
                    dataCadastro: dataAtivacao ? _ctx.formatDate(dataAtivacao) : 'Pendente' ,
                    mediatorFee: mediatorFee && Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL',  }).format(mediatorFee),
                    status: _ctx.statuses[status]
                  }
                }),
                    key: JSON.stringify(_ctx.estabelecimentos),
                    tableId: "cnpj"
                  }, null, 8, ["onUpdate:editTableItem", "values"]))
                ])
              ])
            ]))
          : ((!_ctx.isRoot || _ctx.softwareHouseSelected) && !_ctx.estabelecimentos.length && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 3,
                class: "flex flex-col items-center justify-center h-60 border-b border-gray-200 bg-gray-50 sm:rounded-lg"
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
        : _createCommentVNode("", true),
      (!_ctx.isRoot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_PrimaryButton, {
              class: "ml-auto",
              label: "Convidar",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inviteModal = true))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.inviteModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.inviteModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            (!this.$store.state.isSidebarCollapsed)
              ? (_openBlock(), _createElementBlock("img", _hoisted_33))
              : _createCommentVNode("", true),
            _createVNode(_component_Form, {
              onSubmit: _withModifiers(_ctx.generateLink, ["prevent"]),
              class: "divide-transparent text-left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomInput, {
                  label: "Razão Social",
                  name: "RazaoSocial",
                  validation: _ctx.formValidation.RazaoSocial,
                  value: _ctx.companyForm.RazaoSocial,
                  onChange: _ctx.changeField,
                  class: "col-span-12 sm:col-span-6 lg:col-span-4"
                }, null, 8, ["validation", "value", "onChange"]),
                _createVNode(_component_CustomInput, {
                  loading: false,
                  label: "CNPJ",
                  name: "CNPJ",
                  mask: "##.###.###/####-##",
                  autofocus: true,
                  disabled: false,
                  validation: _ctx.formValidation.CNPJ,
                  value: _ctx.companyForm.CNPJ,
                  onChange: _ctx.changeField,
                  class: "p-0 w-full"
                }, null, 8, ["validation", "value", "onChange"]),
                _createVNode(_component_CustomInput, {
                  label: "Tarifa padrão",
                  name: "MediatorFee",
                  type: "currency",
                  onChange: _ctx.changeField,
                  value: _ctx.companyForm.MediatorFee,
                  validation: _ctx.formValidation.MediatorFee,
                  class: "col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                }, null, 8, ["onChange", "value", "validation"]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_PrimaryButton, {
                    icon: _ctx.buttonIcons.save.icon,
                    iconCustomClass: "text-white",
                    label: "Salvar",
                    disabled: !_ctx.buttonNewCompany,
                    class: "ml-auto",
                    type: "submit"
                  }, null, 8, ["icon", "disabled"])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(_ctx.linkModal ? 'block' : 'hidden fade-out')
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.linkModal = false), ["self"]))
      }, [
        _createVNode(_component_Card, {
          class: "w-4/5 bg-white m-auto rounded-lg p-3 z-50",
          width: "w-11/12 md:w-1/2 lg:w-1/3",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_35, [
              _createTextVNode(_toDisplayString(!_ctx.error ? 'Aqui está seu link para iniciar o cadastro no Tecnopay' : _ctx.error) + " ", 1),
              _hoisted_36
            ]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_37, "Aqui está seu link para acessar o cadastro no Tecnopay"))
              : _createCommentVNode("", true),
            _createVNode(_component_Input, {
              modelValue: _ctx.createLink,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.createLink) = $event)),
              disabled: "",
              ref: "createLink",
              label: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_PrimaryButton, {
              class: "ml-auto",
              label: _ctx.copied,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyToClipboard()))
            }, null, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        onHide: _ctx.hide
      }, null, 8, ["label", "onHide"])
    ], 40, _hoisted_38)
  ]))
}